export default "__VITE_ASSET__VgFufRpR__"